import { render, staticRenderFns } from "./NlpWhySatoshi.vue?vue&type=template&id=4f3123de&scoped=true"
import script from "./NlpWhySatoshi.vue?vue&type=script&lang=js"
export * from "./NlpWhySatoshi.vue?vue&type=script&lang=js"
import style0 from "./NlpWhySatoshi.vue?vue&type=style&index=0&id=4f3123de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3123de",
  null
  
)

export default component.exports